import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ChipSelect from "./formComponents/ChipSelect";
import ByteChip from "./icons/ByteChip";
import PriceCard, {
  PriceCardProps,
} from "./displayDataComponents/wallet/PriceCard";
import { Option, PricingPlan } from "../types/utils";
import { Refresh } from "@mui/icons-material";
import { addMonths } from "date-fns";

type Variant = "subscription" | "topup";
export interface CreateSubscriptionProps {
  currentPlan?: number;
  plans?: PricingPlan[];
  onConfirm: (value: number) => void;
  onChangePlanType?: (value: number) => void;
  variant?: Variant;
  subscriptionPlans?: PricingPlan[];
  isUpdate?: boolean;
  nextBillingDate?: string;
  onChipSelect?: (value: number) => void;
  exchangeData: {
    amount: number;
    currencyAmount: number;
    exchangeRate: number;
  } | null;
}

interface VariantProps {
  title: string;
  cardTitle: string;
  cardColor: PriceCardProps["color"];
}

const variantProps: { [key in Variant]: VariantProps } = {
  topup: {
    title: "Select an amount",
    cardTitle: "Stock",
    cardColor: "yellow",
  },
  subscription: {
    title: "Select a package",
    cardTitle: "Subscription",
    cardColor: "blue",
  },
};

const CreateSubscription: React.FC<CreateSubscriptionProps> = ({
  plans,
  currentPlan,
  onConfirm,
  onChangePlanType,
  variant = "subscription",
  isUpdate = false,
  subscriptionPlans = [],
  nextBillingDate,
  onChipSelect,
  exchangeData,
}) => {
  // const defaultSelectedPackage = currentPlan
  //   ? plans.find((p) => p.value === currentPlan)
  //   : undefined;
  // const [selectedPackage, setSelectedPackage] = useState<
  //   PricingPlan | undefined
  // >(defaultSelectedPackage);
  const [isLoading, setIsLoading] = useState(false);
  const selectedVariant = variantProps[variant];

  const handleSelect = () => {
    // if (selectedPackage?.value) {
    setIsLoading(true);
    exchangeData && onConfirm(exchangeData?.amount);
    // }
  };

  // const handleChangeMode = () => {
  //   if (selectedPackage?.value && onChangePlanType) {
  //     setIsLoading(true);
  //     onChangePlanType(selectedPackage?.value);
  //   }
  // };

  // const subscriptionSaving = selectedPackage
  //   ? (selectedPackage.currencyAmount || 0) -
  //     ((subscriptionPlans || []).find((s) => s.value === selectedPackage.value)
  //       ?.currencyAmount || 0)
  //   : 0;
  nextBillingDate = nextBillingDate || addMonths(new Date(), 1).toDateString();
  const [selectedAmount, setSelectedAmount] = useState<number | null>(null);
  const ChipData = [
    {
      label: "200",
      value: 200,
    },
    {
      label: "500",
      value: 500,
    },
    {
      label: "1000",
      value: 1000,
    },
    {
      label: "2500",
      value: 2500,
    },
    {
      label: "5000",
      value: 5000,
    },
    {
      label: "10,000",
      value: 10000,
    },
    {
      label: "25,000",
      value: 25000,
    },
    {
      label: "50,000",
      value: 50000,
    },
    {
      label: "100,000",
      value: 100000,
    },
    {
      label: "150,000",
      value: 150000,
    },
  ];
  const handleAmount = (data: number) => {
    setSelectedAmount(data);
    onChipSelect && onChipSelect(data);
  };
  return (
    <Box>
      <Typography textAlign="center" variant="h3">
        {selectedVariant.title}
      </Typography>
      <Box mt={2}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {/* <ChipSelect options={ChipData} /> */}
          {ChipData?.map((data, index) => (
            <Button
              key={index}
              sx={{
                border: "1px solid #B027CE",
                color: "primary",
                gap: 1,
                bgcolor:
                  selectedAmount === data.value
                    ? "rgba(247, 210, 255, 1)"
                    : "transparent",
                "&:hover": {
                  bgcolor: "rgba(247, 210, 255, 1)",
                },
              }}
              onClick={() => handleAmount(data.value)}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                {data.label}
              </Typography>
              <ByteChip size="small" color="primary" />
            </Button>
          ))}
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="row"
        gap={4}
        mt={4}
      >
        {/* {selectedPackage &&
          defaultSelectedPackage &&
          selectedPackage?.value !== defaultSelectedPackage?.value &&
          variant === "subscription" && (
            <PriceCard
              title="Current plan"
              color={selectedVariant.cardColor}
              tokenValue={defaultSelectedPackage.value}
              unitPrice={defaultSelectedPackage.unitPrice}
              dollarValue={defaultSelectedPackage.currencyAmount}
              isSubscription={true}
              dividerVariant="line"
            />
          )} */}

        {exchangeData && (
          <PriceCard
            title={selectedVariant.cardTitle}
            color={selectedVariant.cardColor}
            tokenValue={exchangeData.amount}
            unitPrice={exchangeData.exchangeRate}
            dollarValue={exchangeData.currencyAmount}
            subtitle={
              variant === "subscription" ? "recurring top-up" : "one-off"
            }
            disabled={isLoading}
            isSubscription={variant === "subscription"}
            onSelect={handleSelect}
          />
        )}
      </Box>
      {/* <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        mt={1}
      >
        {selectedPackage &&
          subscriptionSaving &&
          variant === "topup" &&
          onChangePlanType && (
            <Button
              sx={{ mt: 1 }}
              variant="text"
              color="warning"
              onClick={() => handleChangeMode()}
              endIcon={
                <Refresh
                  color="warning"
                  sx={{ transform: "translateY(-1px)" }}
                />
              }
            >
              Subscribe and save ${(subscriptionSaving / 100).toFixed(2)} on
              this plan
            </Button>
          )}
        {variant === "subscription" && selectedPackage && (
          <Typography mt={1} variant="subtitle1">
            Next billing date: {nextBillingDate}
          </Typography>
        )}
      </Box> */}
    </Box>
  );
};

export default CreateSubscription;
